import styles from './table.module.scss';
import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableFooter, TableSortLabel } from '@mui/material';


import _ from 'lodash';

import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { IconWrapper, ellipsizeMiddle, formatHumanDate, formatToMaxFourDigits } from '@flexo/general';

import { useSelector } from 'react-redux';
import { RIGHT_DRAWER, store } from '@flexo/reducers';


export function InvoicesPeriodDetailsTable(props: any) {

  const { t } = useTranslation();
  const dispatch = store.dispatch;
  const metadata = useSelector((state: any) => state.metadata);
  const rightDrawer = useSelector((state: any) => state.rightDrawer);
  const { no_data_text, rows } = t(`widgets.tables.InvoicesPeriodDetailsTable`, {
    returnObjects: true,
  }) as any;

  const title = t('widgets.tables.InvoicesPeriodDetailsTable.title', { communityName: metadata.selectedEntity?.communityName, period: props.data.data?.period });
  const subtitle = t('widgets.tables.InvoicesPeriodDetailsTable.subtitle', { date: formatHumanDate(props.data.data?.sites[0]?.emission_date ) });
  const columns = rows;
  

  const [storedRows, setStoredRows] = useState<Array<any>>([]);
  const [rowsOrder, setRowsOrder] = useState(['invoice', 'asc']);

  useEffect(() => {

    const _data = props.data.data?.sites.map((site: any) => {
      
      const member = metadata?.entities.members.find((member: any) => member.memberId === site.memberId);
      const memberName = member?.memberFirstName + ' ' + member?.memberLastName;
      
      return {
        ...site,
        memberName,
        siteType: site.siteType[0].siteType

      }
    });
    

    setStoredRows(_data || []);
  }, [props.data]);

  function sortRows(columnId: string) {
    try {
      let _midArray = _.cloneDeep(storedRows);
      let direction = 'asc';

      if (rowsOrder[0] === columnId && rowsOrder[1] === 'asc') {
        direction = 'desc';
      }

      switch (columnId) {
        case 'invoice':
          _midArray = _midArray.sort((a, b) =>
            (
              direction === 'asc'
                ? a.invoice_no.localeCompare(b.invoice_no)
                : b.invoice_no.localeCompare(a.invoice_no)
            )
          );
          break;
        case 'amount':
          _midArray = _midArray.sort((a, b) =>
            (
              direction === 'asc'
                ? a.amount > b.amount
                : a.amount < b.amount
            )
              ? 1
              : -1
          );
          break;
        case 'member':
          _midArray = _midArray.sort((a, b) =>
            (direction === 'asc' ? a.memberName.localeCompare(b.memberName) : b.memberName.localeCompare(a.memberName))
          );
          break;
        case 'site':
          
          _midArray = _midArray.sort((a, b) =>
            (
             direction === 'asc'
                ? a.siteName.localeCompare(b.siteName)
                : b.siteName.localeCompare(a.siteName)
            
            )
          );
          break;
      }

      setRowsOrder([columnId, direction]);
      setStoredRows(_midArray);
    } catch (err: any) {
      // console.warn(err)
    }
  }

  return (
    <div>
      {/* {LOADING_STATE === 'PENDING' && <Shimmer />} */}
      {
        storedRows?.length > 0 ? (
        <div className={ styles.Table__InvoicePeriodDetails__OverflowContainer }>
        <div
          className={`${styles.Table} ${styles.Table__Flex} ${styles.Table__InvoicePeriodDetails}`}
          
          
            >
              
              <div>
            <div className={`${styles.Table__InvoicePeriodDetails__Title}`}>{parse(title)}</div>
                <div className={`${styles.Table__InvoicePeriodDetails__Subtitle}`}>{subtitle}</div>
                <div
                  className={`${styles.Table__InvoicePeriodDetails__Close}`}
                  onClick={() => {
                    dispatch(RIGHT_DRAWER.SetDrawer({
                      type: 'COMMUNITY_PAYMENTS_LIST',
                      drawerConfig: rightDrawer.drawerConfig?.oldData || {}
                    } as any))
                  }}
                >
                  <IconWrapper iconName="cross" />
                </div>
          </div>

          <TableContainer component={Paper} className={``}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  {columns &&
                    columns.map((column: any, column_i: number) => (
                      <TableCell
                        className={`
                ${
                  column.sortable
                    ? styles.Table__Header__Cell__Sortable
                    : styles.Table__Header__Cell__Static
                }
              ${
                column.sortable && rowsOrder[0] === column.field
                  ? styles.Table__Header__Cell__Active
                  : styles.Table__Header__Cell
              }`}
                        key={`invoice_period_detail_table_${column_i}`}
                      >
                        <TableSortLabel
                          active={
                            column.sortable && rowsOrder[0] === column.field
                          }
                          direction={
                            rowsOrder[0] === column.field &&
                            rowsOrder[1] === 'asc'
                              ? 'asc'
                              : 'desc'
                          }
                          onClick={() =>
                            column.sortable ? sortRows(column.field) : null
                          }
                          className={`${styles.Table__Header__Cell}`}
                          IconComponent={() =>
                            rowsOrder[0] === column.field ? (
                              rowsOrder[1] === 'asc' ? (
                                <IconWrapper
                                  iconName="chevron-up"
                                  className={`${styles.Table__TH__Icon}`}
                                />
                              ) : (
                                <IconWrapper
                                  iconName="chevron-down"
                                  className={`${styles.Table__TH__Icon}`}
                                />
                              )
                            ) : (
                              <div style={{ height: 32, width: 19 }}></div>
                            )
                          }
                        >
                          <div> {column.title}</div>
                        </TableSortLabel>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(storedRows || []).map((row) => (
                  <TableRow
                    key={row?.siteId || Math.floor(Math.random() * 100)}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    style={{ height: 100 }}
                    className={``}
                  >
                    <TableCell
                      className={`${
                        !columns?.[0]?.sortable === true &&
                        styles.Table__Cell__Static
                      }`}
                      key={`invoice_period_detail_table_row_${
                        row.siteId
                      }_cell_0`}
                      component="th"
                      scope="row"
                    >
                      <div className={`${styles.Table__Cell__InvoicePeriodDetails__InvoiceNO}`}>
                      <a href={row.url} target="_blank" rel="noopener noreferrer"> {row.invoiceID} <IconWrapper iconName="download" /> </a>
                      </div>
                    </TableCell>

                    <TableCell
                      key={`invoice_period_detail_table_row_${row.siteId}_cell_1`}
                      component="th"
                      scope="row"
                    >
                      <div
                        className={`${
                          !columns?.[0]?.sortable === true &&
                          styles.Table__Cell__Static
                        }`}
                      >
                        <p
                          className={`${styles.Table__Cell__InvoicePeriodDetails__SiteName}`}
                        >
                          { ellipsizeMiddle(row?.siteName || row?.siteType) }
                        </p>
                        <p
                          className={`${styles.Table__Cell__InvoicePeriodDetails__SiteID}`}
                        >
                          { ellipsizeMiddle(row?.pod || row?.siteExternalId) }
                        </p>
                      </div>
                    </TableCell>

                    <TableCell
                      className={`${
                        !columns?.[1]?.sortable === true &&
                        styles.Table__Cell__Static
                      }`}
                      key={`invoice_period_detail_table_row_${row.siteId}_cell_2`}
                      component="th"
                      scope="row"
                    >
                      <div className={`${styles.Table__Cell__InvoicePeriodDetails__Member}`}>
                        <p
                          className={`${styles.Table__Cell__InvoicePeriodDetails__MemberName}`}
                        >
                          {ellipsizeMiddle(row?.memberName) }
                        </p>
                        <p
                          className={`${styles.Table__Cell__InvoicePeriodDetails__MemberID}`}
                          >
                          {ellipsizeMiddle(row?.memberExternalId || row?.memberId) }
                        </p>
                      </div>
                    </TableCell>

                    <TableCell
                      className={`${
                        !columns?.[3]?.sortable === true &&
                        styles.Table__Cell__Static
                      }`}
                      key={`invoice_period_detail_table_row_${row.siteId}_cell_4`}
                      component="th"
                      scope="row"
                    >
                      <div>
                        <div
                        style={{
                          width: '100px',
                          }}
                        >
                          <p
                            className={`${styles.Table__Cell__InvoicePeriodDetails__Amount}`}
                          >
                            {' '}
                            {formatToMaxFourDigits(row?.amount)} <IconWrapper iconName={ `${ row?.paid ? 'paid' : 'not_paid'}`} />
                          </p>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TableCell
                    align="left"
                    className={`${
                      columns[0].sortable &&
                      styles.Table__Footer__Cell__Clickable
                    }`}
                  >
                    <div
                      onClick={() =>
                        columns[0].sortable ? sortRows('invoice') : null
                      }
                      className={`${
                        columns[0].sortable && rowsOrder[0] === 'invoice'
                          ? styles.Table__Footer__Cell__Active
                          : styles.Table__Footer__Cell
                      }`}
                        >

                          {storedRows.length}
                          { ' ' }
                          {
                            storedRows.length === 1
                            ? t('widgets.tables.utils.total_period')
                            : t('widgets.tables.utils.total_periods')
                          }

                      {rowsOrder[0] === 'invoice' ? (
                        rowsOrder[1] === 'asc' ? (
                          <IconWrapper
                            iconName="chevron-up"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        ) : (
                          <IconWrapper
                            iconName="chevron-down"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        )
                      ) : (
                        <div style={{ height: 32, width: 19 }}></div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell
                    align="left"
                    className={`${
                      columns[1].sortable &&
                      styles.Table__Footer__Cell__Clickable
                    }`}
                  >
                    {/* <div
                      onClick={() =>
                        columns[1].sortable ? sortRows('amount') : null
                      }
                      className={`${
                        columns[1].sortable && rowsOrder[0] === 'amount'
                          ? styles.Table__Footer__Cell__Active
                          : styles.Table__Footer__Cell
                      }`}
                        >
                          
                      {rowsOrder[0] === 'amount' ? (
                        rowsOrder[1] === 'asc' ? (
                          <IconWrapper
                            iconName="chevron-up"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        ) : (
                          <IconWrapper
                            iconName="chevron-down"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        )
                      ) : (
                        <div style={{ height: 32, width: 19 }}></div>
                      )}
                    </div> */}
                  </TableCell>
                  <TableCell
                    align="left"
                    className={`${
                      columns[2].sortable &&
                      styles.Table__Footer__Cell__Clickable
                    }`}
                  >
                    
                  </TableCell>
                      <TableCell align="left">
                        

                      <div
                      onClick={() =>
                        columns[2].sortable ? sortRows('amount') : null
                      }
                      className={`${
                        columns[2].sortable && rowsOrder[0] === 'amount'
                          ? styles.Table__Footer__Cell__Active
                          : styles.Table__Footer__Cell
                      }`}
                        >
                          
                          {formatToMaxFourDigits(props.data.data?.received)}
                          { ' ' }
                          {t('widgets.tables.utils.total')}
                          
                          
                      {rowsOrder[0] === 'amount' ? (
                        rowsOrder[1] === 'asc' ? (
                          <IconWrapper
                            iconName="chevron-up"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        ) : (
                          <IconWrapper
                            iconName="chevron-down"
                            className={`${styles.Table__TH__Icon}`}
                          />
                        )
                      ) : (
                        <div style={{ height: 32, width: 19 }}></div>
                      )}
                    </div>

                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
        </div>
      ) : (
        <div
          className={`${styles.Table} mb-3`}
          key={Math.floor(Math.random() * 100)}
        >
          <div className={`${styles.Table__Title}`}>{title}</div>
          <div className={`${styles.Table__NO_DATA}`}> {no_data_text}</div>
        </div>
      )}
    </div>
  );
}

export default InvoicesPeriodDetailsTable;
